<template>
  <v-container fluid v-if="order">

    <v-row v-if="order.status && order.rejection_reason">
      <v-col>
        <v-alert
          prominent
          type="error"
        >
          <v-row align="center">
            <v-col class="grow">
              {{ order.rejection_reason }}
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>

    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">

            <h4
              v-if="order.request_no"
            >
              引取搬入番号: {{ order.request_no }}
            </h4>
            <h4
              v-if="order.request_date"
            >
              積替運搬日: {{ order.request_date | date_format }}
            </h4>
          </v-col>
        </v-row>

        <!-- 事業場(引取場所) -->
        <v-row v-if="order.tenant_location">
          <v-col>
            <h4>事業場（引取場所）</h4>
            <ul style="list-style: none">
              <li>{{ order.tenant_location.name }}</li>
              <li v-if="order.tenant_location.address">
                <span v-if="order.tenant_location.zip_code">〒{{ order.tenant_location.zip_code }}&nbsp;</span>
                {{ order.tenant_location.address }}
              </li>
              <li v-if="order.tenant_location.phone_number">
                電話番号: {{ order.tenant_location.phone_number }}
              </li>
            </ul>
          </v-col>
          <v-col v-if="order.transporter">
            <h4>引取業者</h4>
            <ul style="list-style: none">
              <li>{{ order.transporter.name }}</li>
              <li v-if="order.transporter.address">
                <span v-if="order.transporter.zip_code">〒{{ order.transporter.zip_code }}&nbsp;</span>
                {{ order.transporter.address }}
              </li>
              <li v-if="order.transporter.phone_number">
                電話番号: {{ order.transporter.phone_number }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="order.trader">
            <h4>運搬先事業者</h4>
            <ul style="list-style: none">
              <li>{{ order.trader.name }}</li>
              <li v-if="order.trader.address">
                <span v-if="order.trader.zip_code">〒{{ order.trader.zip_code }}&nbsp;</span>
                {{ order.trader.address }}
              </li>
              <li v-if="order.trader.phone_number">
                電話番号: {{ order.trader.phone_number }}
              </li>
            </ul>
          </v-col>
          <v-col>
            <h4>運搬先事業場</h4>
            <ul style="list-style: none">
              <li>{{ order.trader_location.name }}</li>
              <li v-if="order.trader_location.address">
                <span v-if="order.trader_location.zip_code">〒{{ order.trader_location.zip_code }}&nbsp;</span>
                {{ order.trader_location.address }}
              </li>
              <li v-if="order.trader_location.phone_number">
                電話番号: {{ order.trader_location.phone_number }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <!-- /事業場(引取場所) -->

      </v-card-text>
      <v-card-text>
        <v-card flat>
          <v-card-actions
            v-if="editMode"
          >
            <!-- ボタン -->
            <v-spacer />
            <v-btn

              color="primary"
              class="text-h6"
              dark
              x-large
              @click="callPickingRequestDialog"
            >
              積替運搬編集
            </v-btn>
            <!-- /ボタン -->
          </v-card-actions>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="manifests"
              :items-per-page="-1"
              dense
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.collected_date`]="{item}">
                {{ item.collected_date | date_format }}
              </template>
              <template v-slot:[`item.driver`]="{item}">
                <span v-if="item.driver">{{ item.driver.name }}</span>
              </template>
              <template v-slot:[`item.emission`]="{item}">
                <div v-if="item.emission">
                  {{ item.emission.name }}
                  <v-tooltip
                    top
                    :open-on-hover="false"
                  >
                    <template #activator="{ on }">
                      <v-btn
                        v-if="item.emission.address"
                        icon
                        small
                        retain-focus-on-click
                        @click="on.click"
                        @blur="on.blur"
                      >
                        <v-icon small>
                          mdi-map-marker-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <small
                      v-if="item.emission.address"
                    >
                      {{ item.emission.address }}
                    </small>
                  </v-tooltip>
                </div>
              </template>

              <template v-slot:[`item.emission_location`]="{ item }">
                <div v-if="item.emission_location">
                  {{ item.emission_location.name }}
                  <v-tooltip
                    top
                    :open-on-hover="false"
                  >
                    <template #activator="{ on }">
                      <v-btn
                        v-if="item.emission_location.address"
                        icon
                        small
                        retain-focus-on-click
                        @click="on.click"
                        @blur="on.blur"
                      >
                        <v-icon small>
                          mdi-map-marker-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <small
                      v-if="item.emission_location.address"
                    >
                      {{ item.emission_location.address }}
                    </small>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:[`item.registration_completion_date`]="{item}">
                {{ item.registration_completion_date | unix_datetime_format }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-simple-table
                  dense
                >
                  <template v-slot:default>
                    <tbody>
                    <tr>
                      <th>マニフェスト件数</th>
                      <td class="text-right">
                        {{ order.manifest_count }}&nbsp;件
                      </td>
                    </tr>
                    <tr>
                      <th>合計数量</th>
                      <td class="text-right">
                        {{ order.total_pickup_amount }}
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <!-- ページャ -->
            <v-row>
              <v-col>
                <v-pagination
                  v-model="page"
                  :length="pagination.total_pages"
                  :total-visible="totalVisible"
                  circle
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="pageChangeEvent"
                />
              </v-col>
            </v-row>
            <!-- /ページャ -->
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>


    <v-card-text>

    </v-card-text>


    <picking-request-dialog
      :enable-dialog="enablePickingRequestDialog"
      :conditions="searchCondition"
      @cancelCallback="pickingRequestCancelCallback"
      @registerCallback="pickingRequestRegisterCallback"
    />
  </v-container>
</template>

<script>
import PickingRequestDialog from '../dialogs/_PickingRequestDialog'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'DriverOrderRequestsPickup',
  components: {
    PickingRequestDialog,
  },
  mixins: [],
  props: {
    editMode: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      disabledCount: 0,
      enablePickingRequestDialog: false,
      tableHeaders: [
        { value: 'manifest_no', text: 'マニフェスト番号' },
        { value: 'collected_date', text: '回収日' },
        { value: 'emission', text: '排出事業者' },
        { value: 'emission_location', text: '排出事業場' },
        { value: 'item_name', text: '品目' },
        { value: 'registration_completion_date', text: '登録完了日' },
        { value: 'intermediate_disposal', text: '中間処分' },
        { value: 'final_disposal', text: '最終処分' },
      ],
      order: null,
      manifests: [],
      searchCondition: {},
    }
  },
  computed: {
    ...mapState('DriverManifestRequestsPickup', {
      pagination: 'pagination'
    }),
  },
  watch: {},
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }

    this.searchOrderRequestsPickup()

  },
  methods: {
    ...mapActions('DriverOrderRequestsPickup', {
      fetchOrderRequestPickup: 'show',
    }),
    ...mapActions('DriverManifestRequestsPickup', {
      fetchManifestRequestPickup: 'show',
    }),

    /**
     * 積替運搬取得
     */
    searchOrderRequestsPickup () {
      this.fetchOrderRequestPickup({id: this.$route.params.id}).then((content) => {
        this.order = content
        // ダイアログで使用されるオーダー情報
        // オーダーID（編集時のみ）
        this.searchCondition.order_id = this.order.id
        // オーダー引取ID（編集時のみ）
        this.searchCondition.order_pickup_id = this.order.order_pickup_id
        // 積替運搬日
        this.searchCondition.request_date = this.order.request_date
        // 事業場（引取場所）
        this.searchCondition.trader_location_code = this.order.tenant_location.code
        // 事業場名（引取場所）
        this.searchCondition.trader_location_name = this.order.tenant_location.name
        // 引取業者
        this.searchCondition.transport_id = this.order.transporter.id
        // 引取業者名
        this.searchCondition.transport_name = this.order.transporter.name
        // 運搬先事業者ID
        this.searchCondition.trader_id = this.order.trader.id
        // 運搬事業者名
        this.searchCondition.trader_name = this.order.trader.name
        // 運搬先事業場コード
        this.searchCondition.to_trader_location_code = this.order.trader_location.code
        // 運搬先事業場名
        this.searchCondition.to_trader_location_name = this.order.trader_location.name
      })
      this.fetchManifestRequestPickup({id: this.$route.params.id, page: this.page}).then((content) => {
        this.manifests = content.manifests
      })
    },
    /**
     * ページ チェンジイベント
     */
    pageChangeEvent () {
      this.searchOrderRequestsPickup()
    },
    /**
     * 引取連絡編集ボタン クリックイベント
     */
    callPickingRequestDialog () {
      this.enablePickingRequestDialog = true
    },
    /**
     * 引取連絡 登録ボタンコールバック
     */
    pickingRequestRegisterCallback () {
      this.pickingRequestCancelCallback()
      this.searchOrderRequestsPickup()
    },
    /**
     * 引取連絡 閉じるボタンコールバック
     */
    pickingRequestCancelCallback () {
      this.enablePickingRequestDialog = false
    },
    /**
     * 閉じるボタンクリックイベント
     */
    closeButtonClickEvent () {
      this.$router.push( { name: 'DriverOrderRequests' } )
    },
  }
}
</script>
<style lang="scss">
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
</style>
<style scoped lang="scss">

.status-card {
  & .image-col {
    padding-top: 0;padding-bottom: 0;
    display: inline-flex;
  }
  & .status-col {
    padding-left: 0;padding-right: 0;
  }
}

.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
    &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

.v-tooltip__content {
  opacity: 1!important;
  background-color: #ffffff !important;
  border: 1px solid #dddddd !important;
  color: #565656 !important;
}

</style>
